// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}

.price {
  font-size: 14px;
  color: var(--ion-color-black);
  font-weight: 400;
  text-align: end;
}

ion-label {
  font-size: 14px;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #ffffff;
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.pfand {
  font-size: 10px;
}

ion-checkbox {
  --color: var(--ion-color-secondary);
  --ion-color-contrast: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;;AAEA;EACC,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;AACD;;AAEA;EACC,eAAA;AACD;;AAEA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AACD;;AAEA;EACC,qBAAA;AACD;;AACA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAED;;AACA;EACC,eAAA;AAED;;AACA;EACC,mCAAA;EACA,qCAAA;AAED","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n}\n\n.price {\n\tfont-size: 14px;\n\tcolor: var(--ion-color-black);\n\tfont-weight: 400;\n\ttext-align: end;\n}\n\nion-label {\n\tfont-size: 14px;\n}\n\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\nion-item {\n\tbackground: #ffffff;\n\tborder-radius: 5px;\n\tmargin-top: 10px;\n\tborder: 0.5px solid #e2dcd5;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n\nion-checkbox {\n\t--color: var(--ion-color-secondary);\n\t--ion-color-contrast: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
